"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCalendarOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22 4V2h-2v2h-8V2h-2v2H4v24h24V4zM10 6v2h2V6h8v2h2V6h4v5H6V6zM6 26V13h20v13z" }),
        React.createElement("path", { d: "M10 16h2v2h-2zM15 16h2v2h-2zM20 16h2v2h-2zM10 21h2v2h-2zM15 21h2v2h-2zM20 21h2v2h-2z" })));
}
exports.default = SvgCalendarOutline;
//# sourceMappingURL=CalendarOutline.js.map